/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowParallelVIcon16Solid = forwardRef('ArrowParallelVIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3 5.203V13a1 1 0 1 0 2 0V5.203l1.24 1.448a1 1 0 0 0 1.52-1.302L5.47 2.679a1.927 1.927 0 0 0-1.357-.673 1.012 1.012 0 0 0-.228 0c-.503.03-.997.254-1.357.674L.241 5.349a1 1 0 1 0 1.518 1.302L3 5.203Z" }),
        React.createElement("path", { d: "M11.113 13.994a1.006 1.006 0 0 1-.226 0 1.927 1.927 0 0 1-1.358-.674l-2.288-2.67a1 1 0 0 1 1.518-1.3L10 10.796V3a1 1 0 1 1 2 0v7.797l1.24-1.448a1 1 0 1 1 1.52 1.302l-2.289 2.67c-.36.42-.854.643-1.358.673Z" })));
});
